



























import { Component, Vue, Prop } from 'vue-property-decorator';
import { AUDIENCE_STATUS } from '@/const/status/index';

@Component<AudienceStatusColumn>({
    name: 'AudienceStatusColumn',
})
export default class AudienceStatusColumn extends Vue {
    @Prop({ required: true, type: String }) private label!: string;
    @Prop({ type: String, default: 'left' }) private align!: string;
    @Prop({ type: [String, Number], default: '' }) private width!: number | string;
    @Prop({ type: [String, Number], default: 120 }) private minWidth!: number | string;
    @Prop({ type: [Boolean, String], default: false }) private sortable!: boolean | string;

    @Prop({ type: String, default: 'status' }) private status!: string;

    private AUDIENCE_STATUS = AUDIENCE_STATUS;
}
